import $$ from 'jquery'
//FIXME rewrite to function and add element on request
let $root = $$('<div class="exo-root exo-reset"></div>');

$$(_ => {
    $root.appendTo($$('body'))
})
export default $root;